module.exports = __webpack_public_path__ + "img/wx_pay@2x.d55d3867.png";